import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import {
  PageContentLayout,
  PageHeaderLayout,
  SideMenu,
} from 'melp-design/components';
import { ROUTES } from 'config';
import { useRouteMatch } from 'react-router-dom';
import { useAdminContentReviewsPendingCount } from 'store/admin-content-reviews';

export const AdminSuppliersLayout: FC = ({ children }) => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();
  const { data: pendingContentReviews } = useAdminContentReviewsPendingCount();

  return (
    <Stack gap={2}>
      <PageHeaderLayout
        breadcrumbs={[
          {
            label: t('menu.suppliers'),
          },
        ]}
      />

      <PageContentLayout
        sidebar={
          <SideMenu
            tabs={[
              {
                key: 'suppliers',
                label: t('menu.suppliers'),
                url: ROUTES.admin.suppliers.list,
                isActive: path === ROUTES.admin.suppliers.list,
              },
              {
                key: 'content-reviews',
                label: t('contentReviews.title', {
                  defaultValue: 'Content reviews',
                }),
                url: ROUTES.admin.contentReviews.list,
                isActive: path === ROUTES.admin.contentReviews.list,
                badge: pendingContentReviews,
              },
              {
                key: 'terms',
                label: t('termsAndConditions.title', {
                  defaultValue: 'Terms/Conditions',
                }),
                url: ROUTES.admin.terms.list,
                isActive: path === ROUTES.admin.terms.list,
              },
            ]}
          />
        }
      >
        {children}
      </PageContentLayout>
    </Stack>
  );
};
